"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandleClickOutside = void 0;
var react_1 = require("react");
var toArray_1 = require("../toArray");
/**
 *
 * @param {*} ref can be a ref or an array of refs
 * @param {*} setShowOptions
 * @param {*} options
 */
var useHandleClickOutside = function (ref, setShowOptions, options) {
    if (options === void 0) { options = {}; }
    var _a = options.enabled, enabled = _a === void 0 ? true : _a;
    var handleClickOutside = function (event) {
        if (!enabled)
            return;
        if ((0, toArray_1.toArray)(ref).every(function (refD) { return refD.current && !refD.current.contains(event.target); })) {
            //clicked outside editor
            setShowOptions(false);
        }
    };
    (0, react_1.useEffect)(function () {
        document.addEventListener('mousedown', handleClickOutside); //its very important for this to be mousedown. 'click' acts unpredictable
        return function () { return document.removeEventListener('mousedown', handleClickOutside); };
    }, [enabled]);
};
exports.useHandleClickOutside = useHandleClickOutside;
//
